import React from "react";

import BankList from "./../../../lib/data/bank.static";
import { getMaskingLen } from "./../../../lib/utils";
import { getMemberBanks } from "./../../../lib/api/api.data";
import { getFEWalletParams } from "./../../../../platform.pay.config";

import translate from "./../../../lib/translate/TranslateJs";


class MemberBanks extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            bankIcon: "",
            memberBanks: []
        }

        this.feWalletParams = getFEWalletParams();

    }
    componentDidMount() {
        const MemberBankType = {
            M2: "Withdrawal",
            M3: "all"
        }
        let flag = this.feWalletParams.languageType == 'M2'
        getMemberBanks(MemberBankType[this.feWalletParams.languageType]).then((res) => {
            if (Array.isArray(res) && res.length) {
                let list = res;

                list.forEach((v) => {
                    v.accountMaskNum = getMaskingLen(v.accountNumber, -3);
                    v.maskName = ((flag ? v.bankNameLocal : v.bankNameEn) + " - " + v.accountMaskNum.replace(/\*/ig,"•"));
                    v.imgName = v.bankNameEn ? v.bankNameEn.replace(/\s/ig, "").replace(/[\.\(\),]/g, "").toLocaleUpperCase() : "default";
                })

                if (this.props.showAddUserBank) { //银行卡没有限制
                    list.push({
                        type: "push",
                        accountNumber: -1,
                        name: translate("添加银行账户")()
                    });
                }

                this.setState({
                    memberBanks: res
                }, () => {
                    this.changeCallback(res[0].accountNumber);
                    this.props.setCurrFormData({"memberbank": res[0].accountNumber});
                    this.props.getMemberTotalBank(res || [])
                });
            }
        })
    }
    changeCallback = (v) => {
        if (v === -1) {
            this.addBankInfo();
            return;
        }
        // 传出选中值到父元素
        if (typeof this.props.setCurrMemberBank === "function") {
            let currMemberBank = {};
            this.state.memberBanks.some((item) => {
                if (item.accountNumber === v) {
                    currMemberBank = item;
                    return true;
                }
            })
            this.props.setCurrMemberBank(currMemberBank);
        }
        return true;
    }
    addBankInfo = () => {
        this.feWalletParams.goAddBankInfo("bank", '', () => {
            this.componentDidMount()
        });
    }
    render() {

        const { Item, Select, AddBankButton } = this.props;
        const { label } = this.props;
        const { memberBanks } = this.state;

        return <Item
            fieldName="memberbank"
            label={label || translate("提款账户")()}
            rules={[{
                required: true,
                message: translate("请选择银行账户")()
            }]}
        >
            {(control) => {
                return Array.isArray(memberBanks) && memberBanks.length > 0 && !!memberBanks[0].accountNumber ? <Select
                    valueKey="accountNumber"
                    valueName={this.feWalletParams.languageType == 'M2' ? "bankNameLocal" : 'bankNameEn'}
                    valueNumber="accountMaskNum"
                    maskName="maskName"
                    isSearch={false}
                    isShowImg={true}
                    placeholder={label || translate("选择银行账户")()}
                    currValue={control.value}
                    memberBankList={memberBanks}
                    addEvent={this.addBankInfo}
                    onSelectChange={(v) => {
                        this.changeCallback(v) === true && control.onChange(v);
                    }}
                /> : <AddBankButton goAddBankInfo={this.addBankInfo} />
            }}
        </Item>

    }
}

export default MemberBanks
